import React, { useState } from 'react'
import { Button, Tag, Row, Col } from 'antd'
import {
  CheckCircleOutlined,
  ClockCircleOutlined
} from '@ant-design/icons'
import ComplaintModal from './ComplaintModal'

export default function ComplaintMapPanel({
  complaint,
  onClose,
  onResolve,
  onReopen,
  onUpdate,
  onRefresh,
  readOnly = false,
  canViewSidebar = false,
  open
}) {
  const [showModal, setShowModal] = useState(false)

  if (!complaint || !open) return null

  const {
    id,
    community,
    date,
    description,
    status,
    observations,
    resolvedBy,
    resolvedAt
  } = complaint

  const resolved = status === 1

  return (
    <>
      <div
        style={{
          position: 'fixed',
          left: !canViewSidebar ? 0 : 260,
          right: 0,
          bottom: 0,
          zIndex: 1001,
          background: 'rgba(247, 247, 247, 0.95)',
          boxShadow: '0 -16px 32px -8px #0075C944',
          padding: '12px 16px',
          maxHeight: '40vh',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12
            }}
          >
            <span
              style={{
                fontWeight: 600,
                fontSize: 18,
                color: '#0075C9'
              }}
            >
              Complaint {id}
            </span>

            {resolved ? (
              <Tag icon={<CheckCircleOutlined />} color="success">
                Resolved
              </Tag>
            ) : (
              <Tag icon={<ClockCircleOutlined />} color="warning">
                Pending
              </Tag>
            )}
          </div>

          <button
            onClick={onClose}
            style={{
              border: 'none',
              background: 'none',
              fontSize: 22,
              color: '#bbb',
              cursor: 'pointer'
            }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div
          style={{
            background: '#fff',
            borderRadius: 6,
            padding: 16,
            flex: 1,
            overflowY: 'auto'
          }}
        >
          <Row gutter={[16, 12]}>
            <Col xs={24} sm={12}>
              <div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  Community
                </div>
                <div>{community}</div>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  Date
                </div>
                <div>{date}</div>
              </div>
            </Col>

            <Col span={24}>
              <div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  Description
                </div>
                <div>{description}</div>
              </div>
            </Col>

            {observations && (
              <Col span={24}>
                <div>
                  <div style={{ fontSize: 12, color: '#666' }}>
                    Observations
                  </div>
                  <div>{observations}</div>
                </div>
              </Col>
            )}

            {resolved && (
              <>
                <Col xs={24} sm={12}>
                  <div>
                    <div style={{ fontSize: 12, color: '#666' }}>
                      Resolved by
                    </div>
                    <div>{resolvedBy || '-'}</div>
                  </div>
                </Col>

                <Col xs={24} sm={12}>
                  <div>
                    <div style={{ fontSize: 12, color: '#666' }}>
                      Resolved at
                    </div>
                    <div>{resolvedAt || '-'}</div>
                  </div>
                </Col>
              </>
            )}
          </Row>

          {!readOnly && (
            <div style={{ textAlign: 'right', marginTop: 20 }}>
              <Button type="primary" onClick={() => setShowModal(true)}>
                Edit Complaint
              </Button>
            </div>
          )}
        </div>
      </div>

      <ComplaintModal
        open={showModal}
        mode="edit"
        initialValues={{ ...complaint }}
        status={status}
        readOnly={readOnly}
        onCancel={() => setShowModal(false)}
        onUpdate={(updatedData, form) => {
          onUpdate?.(id, updatedData, form)
          setShowModal(false)
        }}
        onReopen={(formId, form) => {
          onReopen?.(id, form)
          setShowModal(false)
        }}
        onResolve={(formId, form) => {
          onResolve?.(id, form)
          setShowModal(false)
        }}
      />
    </>
  )
}
